import { useSessionStorage as useMantineSessionStorage } from '@mantine/hooks';

export const useSessionStorage = useMantineSessionStorage;
